import React from 'react'
import { SidebarButton, SidebarSection, SidebarSectionTitle } from '../style'
import { Paperclip, User, Clock, CheckSquare, Tag } from 'lucide-react'

const Options = () => {
  return (
    <SidebarSection>
      <SidebarSectionTitle>Adicionar na OP</SidebarSectionTitle>
      <SidebarButton>
        <User size={14} /> Membros
      </SidebarButton>
      <SidebarButton>
        <Tag size={14} />
        Tags
      </SidebarButton>
      <SidebarButton>
        <CheckSquare size={14} />
        Checklist
      </SidebarButton>
      <SidebarButton>
        <Clock size={14} />
        Data limite
      </SidebarButton>
      <SidebarButton>
        <Paperclip size={14} />
        Anexo
      </SidebarButton>
    </SidebarSection>
  )
}

export default Options